import React, {ReactElement} from 'react';
import HowDoesItWorkItem, {HowDoesItWorkContentItem} from './HowDoesItWorkItem';
import './HowDoesItWorkPoints.scss';

interface Props {
  className?: string;
  content: HowDoesItWorkContentItem[];
}

function HowDoesItWorkPoints({className, content}: Props): ReactElement {
  return (
    <div className={`howDoesItWorkPoints ${className || ''}`.trim()}>
      {content.map(({title, description, number}) => (
        <HowDoesItWorkItem key={number} number={number} title={title} description={description} />
      ))}
    </div>
  );
}

export default HowDoesItWorkPoints;
